@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.currency

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2024/04/01.
 */
class CurrencyDto(
        val id: Int?,
        val name: String,
        val rate: Double,
        val timezone: String
)
